module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Network Contribution","littleTitle":"Computing Task TOP100","email":"Account","macAddress":"Mac Address","revenue":"Revenue","ranking":"Ranking","contribution":"Contribution","deviceType":"Device Type"},"zn":{"pageTitle":"全网贡献","littleTitle":"计算任务昨日贡献TOP100","email":"帐号","macAddress":"设备","revenue":"收益","ranking":"排名","contribution":"贡献值","deviceType":"设备类型"}}')
  delete Component.options._Ctor
}
